import { BiSort } from 'react-icons/bi'


const SortButton = ({ sortKey, currentSort, setSort }) => {

  return <span>
    <button
      className={sortKey == currentSort.split('-')[0] ? 'text-black font-semibold' : 'text-slate-600 '}
      onClick={() => {
        if (sortKey != currentSort.split('-')[0]) {
          setSort(`${sortKey}-dec`)
        } else if (currentSort.split('-')[1] == 'dec') {
          setSort(`${sortKey}-asc`)
        } else {
          setSort(`${sortKey}-dec`)
        }
      }}
    ><BiSort /> </button>


  </span>
}

export default SortButton
